import styled from 'styled-components';
import { PushOrderForm } from '../../components';

export const StyledContainer = styled.div`
  padding: 1.5rem 2.5rem;
`;

export const StyledPushOrderForm = styled(PushOrderForm)`
  max-width: 35rem;
`;
